module.exports = __webpack_public_path__ + "media/images/companyPage/customer_focus-ea1bee7b4a73eee40d72faced7b5ff11.svg";